import React, { useEffect, useLayoutEffect, useState } from 'react';
import TemplateListDumb from './TemplateListDumb';
import queryString from 'query-string';
import { withRouter, useHistory, useLocation } from 'react-router-dom';
import { useUser, useList, useTemplate, useJob } from 'components/hooks';
import { formatProjectItems } from 'helpers';
import { withRequest } from 'hoc';
import { CircularProgress, Backdrop } from '@mui/material';
import { Alert, ErrorScreen, ModalAlert, ModalJobAlert } from 'components/common';
import { JobSchema } from 'schemas';
import { ROUTES } from 'consts';


const TemplateListSmart = (props) => {
  const { parameters, filters, setFilters } = useUser();
  const projects = formatProjectItems(parameters);
  const projectsMap = projects.reduce((a, v) => ({ ...a, [v.value]: v}), {});
  const { getContentList, content, error, isLoaded } = useList('templates');
  const history = useHistory();
  const template = useTemplate();
  const job = useJob();
  const location = useLocation();
  const [openModal, setOpenModal] = useState(false);
  const [openModalRunJob, setOpenModalRunJob] = useState(false);
  const [templateSelected, setTemplateSelected] = useState();
  const [definitions, setDefinitios] = useState(null);
  let { search, project=filters.project } = queryString.parse(props.location.search);
  const [execute, setExecute] = useState(false);
  const [runError, setRunError] = useState(0);

  const handleListPage = () => {
    if (project !== filters.project) setFilters({ project });
    if (project && !!projectsMap[project]) {
      getContentList({
        query: {
          search,
          projectId: project,
          type: 'SI',
        },
      });
    } else history.push(`?project=${projects[0].value}`);
  };

  const handleSearch = (data) => {
    const {pathname, search} = location;
    const currentLocation = `${pathname}${search}`;
    let routeToPush = `${ROUTES.TEMPLATE_LIST}?project=${data.project}`;
    if (data?.search && data.search.trim()) routeToPush += `&search=${data.search.trim()}`;

    if (currentLocation === routeToPush) {
      handleListPage();
    } else {
      history.push(routeToPush);
    }
  };

  const handleCreate = () => {
    template.cleanUpMessage();
    history.push(ROUTES.TEMPLATE_CREATE);
  };

  const handleEdit = (templateData) => {
    template.cleanUpMessage();
    const { worktemplate_id } = templateData;
    history.push(`${ROUTES.TEMPLATE_EDIT}/${worktemplate_id}`);
  };

  const handleView = (templateData) => {
    template.cleanUpMessage();
    const { worktemplate_id } = templateData;
    history.push(`${ROUTES.TEMPLATE_VIEW}/${worktemplate_id}`);
  };

  const handleDelete = () => {
    const { worktemplate_id } = templateSelected;
    template.deleteTemplate({
      body: { worktemplate_id },
    });
    setOpenModal(false);
  };

  const handleModalDelete = (template) => {
    setTemplateSelected(template);
    setOpenModal(true);
  };

  const handleRunJob = (data) => {
    let { worktemplate_id, name, type } = templateSelected;

    const jobToRun = new JobSchema();
    jobToRun.setValues({
      worktemplate_id,
      name,
      type,
      userInteraction: data
    });

    job.postJobRun({
      body: { ...jobToRun.values },
    });
    setExecute(true);
    setOpenModalRunJob(false);
  };

  const handleModalRunJob = (template) => {
    const definitions = JSON.parse(template.user_interaction);
    if (definitions) {
      setDefinitios([{
        worktemplate_id: template.worktemplate_id,
        user_interaction: template.user_interaction
      }]);
      setTemplateSelected(template);
      setOpenModalRunJob(true);
    }
  };

  const handleCloseModalRunJob = () => {
    setOpenModalRunJob(false);
    template.cleanUp();
  };

  const alerts = [
    {
      severity: 'success',
      open: template.success.post,
      message: 'templateList.components.alert.success',
    },
    {
      severity: 'success',
      open: template.success.delete,
      message: 'templateList.components.alert.deleteSuccess',
    },
    {
      severity: 'info',
      open: template.success.put,
      message: 'templateList.components.alert.putSuccess',
    },
    {
      severity: 'error',
      open: template.error.put,
      message: 'templateList.components.alert.error',
    },
    {
      severity: 'error',
      open: template.error.delete,
      message: 'templateList.components.alert.error',
    },
    {
      severity: 'error',
      open: template.error.post,
      message: 'templateList.components.alert.error',
    },
    {
      severity: 'error',
      open: job.error.post,
      message: 'templateList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: template.error.getRun,
      message: 'templateList.components.alert.errorJob',
    },
    {
      severity: 'error',
      open: runError,
      message: runError === 2 ? 
                'templateList.components.alert.errorJobInventory' :
                'templateList.components.alert.errorJob'
    },
  ];

  useEffect(() => {
    handleListPage({ ...filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [search, project]);

  useLayoutEffect(() => {
    if (filters.project) handleSearch({ project: filters.project });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (
      template.success.post ||
      template.success.put ||
      template.success.delete
    ) {
      handleListPage();
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [
    template.success.post,
    template.success.put,
    template.success.delete,
  ]);

  useEffect(() => {
    
    if (job.success.post && execute) {
      // alert(JSON.stringify(job.data));
      // {"result":-1,"mensaje":"Inventario en uso"}
      // {"result":1,"job_id":1947539}
      setExecute(false)
      if (job.data && job.data.result === 1 && job.data.job_id){
        history.push(`${ROUTES.JOB_RUN_TEMPLATE}/${job.data.job_id}`);
      } else {
        if (job.data && job.data.mensaje === "Inventario en uso"){
          setRunError(2);
        } else {
          setRunError(1);
        }
      }
    }

    return () => job.cleanUp();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [job.success.post]);

  return (
    <>
      <Backdrop
        sx={{ zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={job.isLoaded.post}
      >
        <CircularProgress color="primary" />
      </Backdrop>

      { error ? (
        <ErrorScreen />
      ) : (
        <TemplateListDumb
          handleSearch={handleSearch}
          searchValue={search}
          handleCreate={handleCreate}
          handleEdit={handleEdit}
          handleView={handleView}
          handleDelete={handleModalDelete}
          handleRunJob={handleModalRunJob}
          content={content}
          options={projects}
          isLoaded={isLoaded}
          defaultValues={{
            search,
            project: !project ? projects[0].value : project,
          }}
        />
      )}
      { alerts.map((alert, index) => (
        <Alert
          key={index}
          severity={alert.severity}
          handleClose={() => {template.cleanUpMessage(); setRunError(0)}}
          open={alert.open}
          message={alert.message}
        />
      ))}

      <ModalAlert
        open={openModal}
        handleClose={() => setOpenModal(false)}
        handleConfirm={handleDelete}
      />

      <ModalJobAlert
        open={openModalRunJob}
        data={definitions}
        handleClose={handleCloseModalRunJob}
        handleConfirm={handleRunJob}
      />
    </>
  );
};

export default withRequest(withRouter(TemplateListSmart));
